// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../assets/stylesheets/variables.css\"","customWhite":"#ffffff","body":"_2lYHSCAcM6vA2s-47YYZeS","caption":"_1dJD2pSCq2-UhXWE_3mRfd","dropdownZIndex":"1","lightGrey":"#fcfcfc","borderGrey":"#d5dfdf","container":"z32xas-Yp2UV5UHxNzWeg","dropdown":"IL1Y2v9dFhb6cEbU72Jku","suggestion":"_1lOeqDA-o12yQwmgQLVfs4 _1dJD2pSCq2-UhXWE_3mRfd","spinner":"_2jY29KsMM_cuBqPkmNdsGw","spinnerImage":"_2t1BYg-QImlLJ6Quqqxp26"};


//////////////////
// WEBPACK FOOTER
// ./src/common/street-autocomplete-input-v2/StreetAutocompleteInputV2.css
// module id = 458
// module chunks = 0 1 2